import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { updatePropertyStatus } from '../../utils/api/api';
import Modal from '../../elements/Modal';

const UpdateStatusModal = ({ property, isOpen, onClose, onUpdateSuccess }) => {
    const [status, setStatus] = useState(property.status || '');
    const [loading, setLoading] = useState(false);

    const handleUpdateStatus = async () => {
        setLoading(true);
        try {
            const payload = {
                id: property.id,
                status,
            };
            await updatePropertyStatus(payload); 
            toast.success('Status updated successfully');
            onUpdateSuccess();
            onClose();
        } catch (error) {
            toast.error(error.message || 'Failed to update status');
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <Modal onClose={onClose} title="Update Property Status">
            <label className="block text-gray-700 font-medium mb-2" htmlFor="statusSelect">
                Please select the new status for the property:
            </label>
            <select
                id="statusSelect"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                className="border border-gray-300 p-2 rounded-md mt-2 w-full"
            >
                <option value="">Select Status</option>
                <option value="available">Available</option>
                <option value="sold">Sold</option>
                <option value="booked">Booked</option>
                <option value="reserved">Reserved</option>
            </select>
            <div className="flex justify-end mt-4">
                <button
                    onClick={handleUpdateStatus}
                    disabled={loading}
                    className="bg-secondary text-white py-1.5 px-4 rounded-md text-[13px]"
                >
                    {loading ? 'Processing...' : 'Update Status'}
                </button>
                <button
                    onClick={onClose}
                    className="bg-gray-300 text-black py-1.5 px-4 rounded-md ml-2 text-[13px]"
                >
                    Cancel
                </button>
            </div>
        </Modal>
    );
};

export default UpdateStatusModal;
